<template>
  <div v-if="data" class>
    <!-- header start -->
    <van-nav-bar
      title="编辑生平简介"
      left-arrow
      fixed
      :z-index="9999"
      @click-left="onClickLeft"
      right-text="保存"
      @click-right="onClickRight"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <!-- <div class="rich-text-box">
      <vue-html5-editor
        :content="content"
        :height="400"
        :auto-height="true"
        :show-module-name="true"
        @change="updateData"
      ></vue-html5-editor>
    </div> -->
    <!-- <vue-editor v-model="content" :editor-toolbar="customToolbar" /> -->
    <vue-editor id="editor" v-model="content" :editor-toolbar="customToolbar"> </vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      content: "",
      id: 0,
      data: null,
      index: 0,
      data:null,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image",]
      ]
    };
  },
  components: { VueEditor },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      // 保存
      var that = this;
      console.log(that.content);
      // MemorialManageEditDeceasedLifeVue
      this.$store.dispatch({
        type:"MemorialManageEditDeceasedLifeVue",
        "id": that.data.MemorialHallSearchApiModel.DeceasedInformationApiModelList[that.index].Id,
        "lifeIntroduction": that.content,
      }).then(res =>{
        if(res.IsSuccess){
          that.$router.go(-1);
        }
      }, err => {})
    },
    updateData(e = "") {
      var c1 = e.replace(/<img width="100%"/g, "<img");
      var c2 = c1.replace(/<img/g, '<img width="100%"');
      this.content = c2;
      //console.log(this.content);
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      // An example of using FormData
      // NOTE: Your key could be different such as:
      // formData.append('file', file)
      console.log(file,2222222222222222)
      var formData = new FormData();
      formData.append("image", file);

      // axios({
      //   url: "https://fakeapi.yoursite.com/images",
      //   method: "POST",
      //   data: formData
      // })
      //   .then(result => {
      //     let url = result.data.url; // Get url from response
      //     Editor.insertEmbed(cursorLocation, "image", url);
      //     resetUploader();
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    init() {
      var that = this;
      var that = this;
      that.$store
        .dispatch({
          type: "GetMemorialHallSearchApiById",
          id: that.id
        })
        .then(
          res => {
            that.data = res;
            if(!(res.IsSelf)){
              that.$router.go(-1);
            }
            if(res){
              that.content = res.MemorialHallSearchApiModel.DeceasedInformationApiModelList[that.index].LifeIntroduction;
            }
          },
          err => {}
        );
    }
  },
  created() {
    var that = this;
    this.id = this.$route.query.id;
    this.index = this.$route.query.index;
    this.init();
  }
};
</script>

<style scoped>
.rich-text-box {
  margin: 15px;
}
</style>
<style>
.vue-html5-editor {
  padding-top: 39px;
}
.vue-html5-editor > .toolbar {
  position: fixed;
  top: 61px;
  left: 15px;
  right: 15px;
  border: 1px solid #ddd;
}
</style>
